
import { defineComponent, PropType } from 'vue';
import { NButton, NButtonType, NButtonTypes } from '@/uikit';
import { fromFs } from '@/uikit/attachments';

export default defineComponent({
  name: 'FileAttachButton',
  components: { NButton },
  props: {
    accept: { type: String, default: 'image/*' },
    icon: { type: String, default: 'upload' },
    multiple: { type: Boolean, default: false },    
    type: { type: String as PropType<NButtonType>, default: NButtonTypes.Secondary },
    i18n_label: { type: String, default: 'common.photos_upload' }
  },
  emits: ['attach'],
  methods: {
    async attach(): Promise<void> {
      const files = await fromFs(this.accept, true);
      this.$emit('attach', files);
    }
  }
});
